import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrimeNgModule } from './primeng/primeng.module';
import { PipesModule } from './pipes/pipes.module';
import { HttpClientModule } from '@angular/common/http';
import { AppConfigService, initConfig } from '@app/app.config';

@NgModule({
    declarations: [],
    providers: [
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfigService],
            multi: true,
        },
    ],
    imports: [],
    exports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, PrimeNgModule, PipesModule, HttpClientModule],
})
export class SharedModule {}
